module.exports = __webpack_public_path__ + "img/send.c4e8f324.svg";